if (!customElements.get("product-tyle-quick-add")) {
  customElements.define(
    "product-tyle-quick-add",
    class extends HTMLElement {
      constructor() {
        super();
        this.inputs = this.querySelectorAll('input[type="radio"]');
        this.addToCartButton = this.querySelector(".product-tile__quick-add-button");
        this.triggerPopupButton = this.querySelector(".product-tile__quick-add-popup-trigger");
        this.modal = document.querySelector(`#modal-quick-add-product--${this.dataset.sectionId}`);
        this.modalContent = this.modal.querySelector(".quick-add-modal-content");
        this.img = this.querySelector(".product-tile__image img");
        this.closeModal = this.modal.querySelector(".close-quick-add-modal");
        this._abortController = null;
        /** Bloque les doubles déclenchements (souvent avec Flickity tactile sur mobile). */
        this._quickActionLock = false;
      }

      disconnectedCallback() {
        this._abortController?.abort();
        this._abortController = null;
      }

      connectedCallback() {
        this.disconnectedCallback();
        this._abortController = new AbortController();
        const { signal } = this._abortController;

        this.updateOptions();
        this.updateMasterId();
        this.inputs.forEach((input) => {
          input.addEventListener(
            "change",
            (event) => {
              this.onVariantChange(event);
            },
            { signal }
          );
        });
        this.addToCartButton?.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (this._quickActionLock || this.addToCartButton?.disabled) return;
            this._quickActionLock = true;
            this.addToCart().finally(() => {
              this._quickActionLock = false;
            });
          },
          { signal }
        );
        this.triggerPopupButton?.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (this._quickActionLock || this.triggerPopupButton?.disabled) return;
            this._quickActionLock = true;
            this.triggerPopup().finally(() => {
              this._quickActionLock = false;
            });
          },
          { signal }
        );
        this.modal?.addEventListener(
          "click",
          (e) => {
            if (e.target === this.modal) {
              this.closePopup();
            }
          },
          { signal }
        );
        this.closeModal?.addEventListener(
          "click",
          () => {
            this.closePopup();
          },
          { signal }
        );
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia();
      }

      updateOptions() {
        this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (element) => {
          return element.value;
        });
      }

      updateMedia() {
        if (this.currentVariant.featured_media.preview_image.src !== null) {
          this.img.src = this.currentVariant.featured_media.preview_image.src;
          // replace all the srcset with the new one
          // add _300x before the .png to avoid the browser to download the image
          this.img.srcset = this.currentVariant.featured_media.preview_image.src.replace(".png", "_300x.png").replace(".jpg", "_300x.jpg").replace(".jpeg", "_300x.jpeg").replace(".webp", "_300x.webp");
        }
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
        this.dataset.selectedId = this.currentVariant.id;
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      triggerPopup() {
        this.modalContent.innerHTML = "";
        return fetch(this.dataset.productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
            const productElement = responseHTML.querySelector(".product").closest("section");

            // Supprime les éléments inutiles
            const elementsToRemove = [".product__block.product__accordion", "toggle-cross-sell", ".product_thumbnail-list", ".product__image-container", ".product__block.product__description"];
            elementsToRemove.forEach((selector) => {
              productElement.querySelectorAll(selector).forEach((el) => el.remove());
            });

            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            // add a link to the modal that redirect to the product
            const link = document.createElement('a');
            link.href = this.dataset.productUrl;
            link.innerText = 'Voir le produit';
            link.classList.add('quick-add-popup-redirection');
            this.modalContent.querySelector('.product-wrapper .product').appendChild(link);
            // Attache l'événement de fermeture après l'injection
            const atcButton = this.modalContent.querySelector("button[data-add-button]");
            if (atcButton) {
              atcButton.addEventListener("click", (event) => {
                this.closePopup();
              });
            } else {
              console.warn("Add to Cart button not found in modal.");
            }

            // Déclenche l'événement global
            const newProductSection = this.modalContent.querySelector(".product-wrapper");
            if (newProductSection) {
              window.registerProductSection(newProductSection);
            } else {
              console.error("No product section found in modal.");
            }
          })
          .finally(() => {
            this.modal.showModal();
          });
      }

      closePopup() {
        this.modal.close();
      }

      addToCart() {
        let formData = {
          items: [
            {
              id: this.currentVariant.id,
              quantity: 1,
            },
          ],
        };

        return fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json();
          })
          .then((cart) => {
            document.dispatchEvent(
              new CustomEvent("cart:trigger-toggle", {
                detail: {
                  cart: cart,
                  cartOpen: true,
                  quickShopProduct: false
                },
              })
            );
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  );
}
